interface FieldGroup {
  group_name: string
  group_id: number
  sort_order: number
  fields: FormI[]
}

interface FormI {
  name: string
  value?: any
  required?: boolean
  title?: string
  input?: any
  options?: any
}

interface SchemaI {
  properties: object
  required: string[]
  type: string
  groups?: {
    [key: string]: {
      title: string
      sort_order: number
      fields: string[]
    }
  }
}

function injectAddressNoteFromFieldOptions(
  fieldName: string,
  options: any,
  resultObject: Record<string, unknown>,
  resultSchema: SchemaI,
) {
  if (fieldName !== 'address' || !options?.note?.active) {
    return
  }
  resultObject['address_note'] = options.note.value ?? ''
  resultSchema.properties['address_note'] = {
    title: '',
    type: 'string',
    options: {
      type: 'textarea',
      minRows: 1,
      maxRows: 4,
      disabled: Boolean(options.disabled),
      hide_title: true,
      placeholder: 'Примечание к адресу',
    },
  }
}

export const convertData2JsonForm = currentData => {
  if (!currentData) {
    return {
      resultObject: {},
      resultSchema: {
        properties: {},
        required: [],
        type: 'object',
      },
    }
  }

  if (!Array.isArray(currentData)) {
    console.warn('convertData2JsonForm: currentData должен быть массивом', currentData)
    return {
      resultObject: {},
      resultSchema: {
        properties: {},
        required: [],
        type: 'object',
      },
    }
  }

  if (currentData.length === 0) {
    return {
      resultObject: {},
      resultSchema: {
        properties: {},
        required: [],
        type: 'object',
      },
    }
  }

  const isGroupedData =
    currentData[0] &&
    typeof currentData[0] === 'object' &&
    currentData[0].hasOwnProperty('group_name')

  if (isGroupedData) {
    return convertGroupedData2JsonForm(currentData as FieldGroup[])
  } else {
    return convertFlatData2JsonForm(currentData)
  }
}

const convertFlatData2JsonForm = currentData => {
  const resultObject = {}
  const resultSchema: SchemaI = {
    properties: {},
    required: [],
    type: 'object',
  }

  if (!currentData || !Array.isArray(currentData) || currentData.length === 0) {
    return {
      resultObject,
      resultSchema,
    }
  }

  currentData.forEach(({ name, value, options, required, title, input }: FormI) => {
    resultObject[name] = Array.isArray(value) && !value[0] ? null : value

    resultSchema.properties[name] = {
      title: title || name,
      ...input,
      options,
    }
    if (required) {
      resultSchema.required.push(name)
    }
    if (input?.format === 'file-s3') {
      resultSchema.properties[name] = {
        ...resultSchema.properties[name],
        options: {
          ...resultSchema.properties[name]?.options,
          isNewUrl: true,
        },
      }
    }

    injectAddressNoteFromFieldOptions(name, options, resultObject, resultSchema)
  })

  return {
    resultObject,
    resultSchema,
  }
}

const convertGroupedData2JsonForm = (groupedData: FieldGroup[]) => {
  const resultObject = {}
  const resultSchema: SchemaI = {
    properties: {},
    required: [],
    type: 'object',
    groups: {},
  }

  if (!groupedData || !Array.isArray(groupedData) || groupedData.length === 0) {
    return {
      resultObject,
      resultSchema,
    }
  }

  groupedData.forEach(group => {
    const groupFields: string[] = []

    group.fields?.forEach(({ name, value, options, required, title, input }: FormI) => {
      resultObject[name] = Array.isArray(value) && !value[0] ? null : value
      groupFields.push(name)

      resultSchema.properties[name] = {
        title: title || name,
        ...input,
        options,
      }

      if (required) {
        resultSchema.required.push(name)
      }

      if (input?.format === 'file-s3') {
        resultSchema.properties[name] = {
          ...resultSchema.properties[name],
          options: {
            ...resultSchema.properties[name]?.options,
            isNewUrl: true,
          },
        }
      }

      injectAddressNoteFromFieldOptions(name, options, resultObject, resultSchema)
    })

    if (groupFields.length > 0) {
      if (!resultSchema.groups) {
        resultSchema.groups = {}
      }
      resultSchema.groups[group.group_id] = {
        title: group.group_name,
        sort_order: group.sort_order,
        fields: groupFields,
      }
    }
  })

  return {
    resultObject,
    resultSchema,
  }
}
